/**
 * 字符串操作工具函数
 * 适用于所有前端项目（web、admin、mobile）
 */

/**
 * 字符串填充
 * @param {String} str 原字符串
 * @param {Number} len 目标长度
 * @param {String} pad 填充字符
 * @returns {String} 填充后的字符串
 */
export function padding(str, len, pad) {
  str = str + ''
  if (len > str.length) {
    str = Array(len + 1 - str.length).join(pad) + str
  }
  return str
}

/**
 * 解析查询字符串
 * @param {String} url URL字符串
 * @returns {Object} 包含path和query的对象
 */
export function parseQueryString(url) {
  const indexOfQMark = url.indexOf('?')
  const uri = indexOfQMark === -1 ? url : url.substring(0, indexOfQMark)
  const query = indexOfQMark === -1 ? '' : url.substring(indexOfQMark + 1)
  const params = new URLSearchParams(query)
  const obj = {}
  for (let param of params) {
    const k = param[0]
    const v = param[1]
    if (obj[k] === undefined) {
      obj[k] = [v]
    } else {
      obj[k].push(k)
    }
  }
  return { path: uri, query: obj }
}

/**
 * 字符串转整数数组
 * @param {String} string 逗号分隔的字符串,可以为空
 * @returns {Array<Number>} 整数数组,不会为空
 */
export function str2ints(string) {
  return string ? string.split(',').map((item) => (item === 'null' ? null : parseInt(item))) : []
}

/**
 * 字符串转字符串数组
 * @param {String} string 逗号分隔的字符串,可以为空
 * @returns {Array<String>} 字符串数组,不会为空
 */
export function str2arr(string) {
  if (!string) return []
  return string.split(',')
}

/**
 * 判断是否为字符串
 * @param {*} value 目标值
 * @returns 如果是原始字符串或者字符串对象则返回true, 否则返回false
 */
export function isString(value) {
  return Object.prototype.toString.call(value) === '[object String]'
}

/**
 * 判断目标是否合法的网址
 * @param {string} str 网址
 * @returns 是否合法
 */
export function isURL(str) {
  if (!isString(str)) return false
  const value = str.trim()
  if (!value) return false

  // 优先使用URL API（浏览器环境）
  if (typeof URL !== 'undefined') {
    try {
      const url = new URL(value)
      const hostname = url.hostname
      //仅允许 http/https 协议
      if (!['http:', 'https:'].includes(url.protocol)) return false
      //域名至少包含一个点（避免 "http://com" 等无效格式）
      if (!hostname.includes('.')) return false
      return true
    } catch (e) {
      return false
    }
  }

  // 降级到正则表达式（uni-app等环境）
  const pattern = /^(https?):\/\/(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}|(?:\d{1,3}\.){3}\d{1,3})(?::\d{2,5})?(?:[/?#][^\s]*)?$/
  if (!pattern.test(value)) return false
  // 对 IPv4 域名做进一步校验，确保每段不超过 255
  if (/^\d/.test(value)) {
    const ip = value.replace(/^(https?):\/\//, '').split(/[/:?#]/)[0]
    const parts = ip.split('.')
    if (
      parts.some((segment) => {
        if (segment.length === 0 || (segment.length > 1 && segment.startsWith('0'))) return true
        const num = Number(segment)
        return Number.isNaN(num) || num < 0 || num > 255
      })
    ) {
      return false
    }
  }
  return true
}

export default {
  padding,
  parseQueryString,
  str2ints,
  str2arr,
  isString,
  isURL
}
